import { Handle, Position } from '@xyflow/react'
import pgLogo from '@/assets/postgre.png'
import azurePGLogo from '@/assets/msft/Azure-Database-PostgreSQL-Server.svg'
import awsRDSLogo from '@/assets/aws/Arch_Amazon-RDS_64.png'
import gcpCloudSQLLogo from '@/assets/gcp/Cloud-SQL.png'

function PostgresTopNode() {
  const postgresLogo = () => {
    const demoEnv = localStorage.getItem('TARGET')
    if (demoEnv === 'MSFT') {
      return azurePGLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'AWS') {
      return awsRDSLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'GCP') {
      return gcpCloudSQLLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else {
      return pgLogo
    }
  }
  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <a href={import.meta.env.VITE_PGADMIN_ADDRESS} target="_blank" rel="noreferrer">
              <img src={postgresLogo()} alt="Logo" className="custom-node-plc-logo" />
            </a>
          </div>
          <div className="text-center">
            <b>Postgres</b>
          </div>
        </div>
      </div>

      <Handle type="target" position={Position.Top} />
    </div>
  )
}

export default PostgresTopNode
